/* eslint-disable array-callback-return */
/* eslint-disable no-extend-native */

import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
// import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from 'react';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import Hidden from "@mui/material/Hidden";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';


import { timeOffsetString } from '../../ckcore/core/CkUtils';
import Colors from '../../ckcore/core/Colors';
import Config from '../../ckcore/core/Config';
import TxStatus from '../../ckcore/core/TxStatuses';
import TxTypes from '../../ckcore/core/TxTypes';
import User from '../../ckcore/core/User';

import PartnerSendSms from '../sim/PartnerSendSms';
import { Button } from '@mui/material';
import { getDisplayPhone } from '../../ckcore/core/Telcos';
import ValUtils from '../../ckcore/core/ValUtils';
import Roles from '../../ckcore/core/Roles';
import { useKeycloak } from '@react-keycloak/web';

export default function SimListAll(props) {
  const { keycloak } = useKeycloak();

  const classes = useStyles();

  const userObj = props.userObj;
  const activeRole = User.getActiveRole(userObj);
  const [simList, setSimList] = useState([]);
  const [loading, setLoading] = useState(false);

  // console.log("Show simList: " + simList.length + " parnterId: " + userObj.partnerId);

  // const [loading, setLoading] = useState(false);
  const [selectedSim, setSelectedSim] = useState({});
  const [showSendSmsDialog, setShowSendSmsDialog] = useState(false);

  // Open send sms or USSD dialog
  const openSendSmsDialog = (sim) => {
    setSelectedSim(sim);
    setShowSendSmsDialog(true);
  }

  // Close send dialog
  const closeSendSmsDialog = () => {
    setShowSendSmsDialog(false);
  }


  // Check sim balance
  const balanceCheck = () => {

  }


  /**
   * Load all bank accounts
   */
   const loadAllSims = async () => {

    if(loading) {
      return;
    }

    setLoading(true);

    // request get user info
    const ckmsg = {
      txTypeId: TxTypes.ORIGIN_ADMIN_SIM_REPORT,
      timestamp: new Date().getTime(),
      identity: User.getIdentity(),
    };

    // Call server
    try {

      // const rawResponse = await fetch(Config.getServerURL() + "admin=" + JSON.stringify(cksu));
      const rawResponse = await fetch(Config.getServerOriginAdminURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${keycloak.token}`,
        },
        body: JSON.stringify(ckmsg)
      });
      const response = await rawResponse.json();
      if (response.statusId === TxStatus.SUCCESS) {

        setSimList(response.sims);

      } else if (response.statusId === TxStatus.TIMEOUT) {
        console.log("User session timeout. Need to login again");
        props.logoutCallback();
      } else {
        console.log("Load sim list error with statuses: " + response.statusId);
      }
      
    } catch (error) {
      console.log("Error sim list accounts: " + error);
    }

    setLoading(false);
  }

  useEffect(() => {
    try {
      loadAllSims();
    } catch (error) {
      console.log("Error load CKBox sims: " + error);
    }
  }, []); 


  const getCkCoinStatus = (ckCoin) => {

    var message = "Mỗi thông báo biến động số dư của tài khoản ngân hàng được tính là một lượt chuyển khoản.";

    if (ckCoin >= 100) {


      return <Tooltip title={message} aria-label="CKCoin">
        <span className={classes.ckCoinHigh}>Số lượt CK: {ckCoin}</span>
      </Tooltip>;
    } else if (ckCoin > 0) {

      return <Tooltip title={message} aria-label="CKCoin">
        <span className={classes.ckCoinLow}>Số lượt CK: {ckCoin}</span>
      </Tooltip>;
    } else {

      return <Tooltip title={message} aria-label="CKCoin">
        <span className={classes.ckCoinZero}>Số lượt CK: {ckCoin}</span>
      </Tooltip>
    }
  }


  const getSimStatusColor = (simStatus, timestamp) => {

    // fix timestamp
    if (new Date().getTime() - timestamp > 30000) {
      return Colors.YELLOW;
    }

    if (simStatus === "READY") {
      return 'green';
    } else if (simStatus === "READING" || simStatus === "WRITING" || simStatus === "TRANSFERING" || simStatus === "RECHARGING") {
      return Colors.DARK_BLUE;
    } else if (simStatus === "PROCESSING" || simStatus === "TRANSFER_WAITING" || simStatus === "RECHARG_WAITING") {
      return Colors.YELLOW;
    } else if (simStatus === "WAITING") {
      return Colors.YELLOW;
    } else if (simStatus === "NOTFOUND") {
      return 'rgba(0, 0, 0, 0.66)';
    } else if (simStatus === "DISABLE") {
      return 'rgba(0, 0, 0, 0.26)';
    } else if (simStatus === "ERROR" || simStatus === "RECHARGE_ERROR" || simStatus === "TRANSFER_ERROR") {
      return Colors.RED;
    } else {
      return Colors.RED;
    }
  }

  const getUpdateTime = (sim) => {

    return (
      <div className={classes.valueSmall}>{timeOffsetString(sim.timestamp / 1000, new Date().getTime() / 1000)}</div>
    );
  }

  const getModemId = (sim) => {
    if (sim.modemId.includes("CKBOX")) {
      return sim.modemId;
    } else {
      return sim.imei;
    }
  }

  const getSimActions = (sim) => {
    return (<div>
      <Tooltip title="Kiểm tra số dư" aria-label="Balance">
        <IconButton size="small" className={classes.smsButton} onClick={() => balanceCheck(sim)}>
          <AccountBalanceWalletOutlinedIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Gửi SMS" aria-label="Send sms">
        <IconButton size="small" className={classes.smsButton} onClick={() => openSendSmsDialog(sim)}>
          <SendOutlinedIcon />
        </IconButton>
      </Tooltip>
    </div>);
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>

        {
          (simList.length > 0) ? (
            <TableContainer component={Paper}>
              <Table className={classes.table} size="small" aria-label="modem usb table">
                <TableHead>
                  <TableRow className={classes.row}>
                    <TableCell className={classes.colNo}>STT</TableCell>
                    <TableCell className={classes.colPhone}>SĐT</TableCell>
                    <TableCell className={classes.colStatus}>Trạng thái</TableCell>
                    <Hidden mdDown>
                      <TableCell className={classes.colExpired}>Số dư</TableCell>
                      <TableCell className={classes.colExpired}>Hạn dùng</TableCell>
                      <TableCell className={classes.colExpired}>Mã thiết bị</TableCell>
                    </Hidden>
                    <TableCell className={classes.colExpired}>Cập nhật</TableCell>
                    <TableCell className={classes.colActions}>Thao tác</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {simList.map((sim, index) => (
                    <TableRow hover key={index} padding="none" className={classes.row}>
                      <TableCell className={classes.colNo}>{index + 1}</TableCell>
                      <TableCell className={classes.colPhone} style={{ color: getSimStatusColor(sim.state, sim.timestamp) }}>{getDisplayPhone(sim.phone)}</TableCell>
                      <TableCell className={classes.colStatus} style={{ color: getSimStatusColor(sim.state, sim.timestamp) }}>{sim.status}</TableCell>
                      <Hidden mdDown>
                        <TableCell className={classes.colBalance}>{(sim.balance === 0) ? '' : ValUtils.formatMoney(sim.balance) + 'đ'}</TableCell>
                        <TableCell className={classes.colExpired}>{sim.expired}</TableCell>
                        <TableCell className={classes.colExpired}>{getModemId(sim)}</TableCell>
                      </Hidden>
                      <TableCell className={classes.colTime} style={{ color: getSimStatusColor(sim.state, sim.timestamp) }}>{getUpdateTime(sim)}</TableCell>
                      <TableCell className={classes.colActions}>{getSimActions(sim)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) :
            (
              (activeRole.roleId === Roles.ADMIN) &&
              <Box className={classes.guideBox}>
                <Box display="inline" >
                  {
                    /*
                    <Button color="primary" variant="contained" className={classes.downloadButton} onClick={() => downloadCkApp('windows')}>Tải CKApp Windows</Button>
                    <Button color="primary" variant="contained" className={classes.downloadButton} onClick={() => downloadCkApp('linux')}>Tải CKApp Linux</Button>
                    */
                  }
                </Box>
              </Box>
            )
        }

        {
          showSendSmsDialog &&
          <PartnerSendSms open={showSendSmsDialog} closeCallback={closeSendSmsDialog}
            sim={selectedSim}
            userObj={props.userObj}
            partnerObj={props.partnerObj} />
        }


      </ThemeProvider>
    </StyledEngineProvider>
  );
}


const theme = createTheme({
  overrides: {
    MuiTableCell: {
      root: {  //This can be referred from Material UI API documentation.
        padding: '2px 6px',
      },
      sizeSmall: {
        padding: '2px 3px 2px 3px',
      },
    },
    MuiSvgIcon: {
      root: {
        width: 18,
        height: 18,
      }
    },
  },
  palette: {
    primary: {
      main: Colors.BG_BLUE,
    },
    secondary: {
      main: Colors.LIGHT_BLUE,
      contrastText: "#fff" //button text white instead of black
    }
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 16,
    textAlign: 'left',
  },
  title: {
    color: Colors.DARK_BLUE,
    fontWeight: 'bold',
    paddingLeft: 2,
    marginBottom: 6,
  },

  transHead: {
    minHeight: 30,
    padding: '3px 3px',
  },

  guideBox: {
    textAlign: "center",
    margin: "auto",
    padding: 16,
  },
  guideText: {
    textAlign: "center",
    margin: "auto",
    marginBottom: 20,
  },

  ckCoinHigh: {
    fontSize: 14,
    fontWeight: 'bold',
    color: Colors.DARK_GREEN
  },
  ckCoinLow: {
    fontSize: 14,
    fontWeight: 'bold',
    color: Colors.ORANGE
  },
  ckCoinZero: {
    fontSize: 14,
    fontWeight: 'bold',
    color: Colors.RED
  },

  downloadButton: {
    margin: 'auto',
    marginLeft: '20px',
    fontWeight: 'bold'
  },

  modemButton: {
    padding: '0px 6px',
    marginLeft: '8px',
  },

  table: {
    marginTop: 4,
    marginBottom: 0,
    whiteSpace: "nowrap",
  },

  row: {
    height: 30,
    maxHeight: 36,
    fontSize: 12,
  },

  colNo: {
    minWidth: 30,
    textAlign: "center",
    padding: "2px 3px",
  },

  colPhone: {
    minWidth: 80,
    padding: '2px 6px',
    paddingLeft: 16,
  },

  colStatus: {
    minWidth: 110,
    padding: '2px 6px',
    fontWeight: 'bold',
  },

  colBalance: {
    minWidth: 50,
    padding: '2px 12px',
  },

  colExpired: {
    minWidth: 80,
    padding: '2px 12px',
  },

  colTime: {
    minWidth: 110,
    padding: '2px 12px',
  },


  colMessage: {
    minWidth: 222,
    maxWidth: 363,
    overflow: 'hidden',
    padding: '2px 6px',
  },

  colActions: {
    minWidth: 111,
    maxWidth: 111,
    padding: '3px 3px',
    textAlign: 'center',
  },
  valueIn: {
    color: 'green',
    textAlign: 'right',
  },
  valueOut: {
    color: 'orange',
    textAlign: 'right',
  },
  valueBold: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  valueEmpty: {
    color: Colors.DARK_BLUE,
    textAlign: 'center',
    fontSize: 12,
  },

  valueSuccess: {
    color: Colors.DARK_GREEN,
    textAlign: 'center',
    fontSize: 12,
  },
  valueError: {
    color: Colors.RED,
    textAlign: 'center',
    fontSize: 12,
  },

  valueSmall: {
    fontSize: 12,
  },

  smsButton: {
    fontSize: 10,
    padding: '0px 6px',
  },

}));
